{
  "id": "isis",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Ísis",
    "en": "Isis"
  },
  "icon": "gods/isis",
  "portrait": "gods/isis-portrait",
  "modifiers": [
    {
      "target": "popCap",
      "op": "add",
      "value": 5,
      "scope": {
        "ids": ["town-center"]
      },
      "note": "Town Centers and Citadel Centers support +5 population (applies to the starting TC too: 20)."
    },
    {
      "target": "cost",
      "op": "mul",
      "value": 0.9,
      "scope": {
        "tags": ["research"],
        "resources": ["food", "wood", "gold"]
      },
      "except": ["secrets-of-the-titans"],
      "note": "Technologies cost -10% Food/Wood/Gold (not Favor; age-ups and Secrets of the Titans excluded)."
    },
    {
      "target": "cost",
      "op": "add",
      "value": -5,
      "scope": {
        "ids": ["obelisk"],
        "resources": ["gold"]
      },
      "note": "Obelisks cost -5 Gold."
    },
    {
      "target": "buildTime",
      "op": "mul",
      "value": 0.714,
      "scope": {
        "ids": ["obelisk"]
      },
      "note": "Priests build Obelisks 40% faster (rate x1.4 => time /1.4)."
    },
    {
      "target": "favorRate",
      "op": "mul",
      "value": 1.667,
      "scope": {
        "ids": [
          "monument-to-villagers",
          "monument-to-soldiers",
          "monument-to-priests",
          "monument-to-pharaohs",
          "monument-to-gods"
        ]
      },
      "condition": "custom",
      "note": "Only while a Monument is empowered by a Pharaoh: empower favor bonus becomes x2.0 instead of x1.2 (1.2 x 1.667). The file's BasePercent applies to the empower factor itself (EmpowerModify FavorGatherRate 1.2 -> 2.0), so relative to an empowered Monument's favor it is a plain x1.667: op mul is intended."
    }
  ],
  "powers": ["prosperity"],
  "minors": {
    "classical": ["anubis", "bast"],
    "heroic": ["nephthys", "sobek"],
    "mythic": ["osiris", "thoth"]
  },
  "unlocks": ["flood-of-the-nile"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml, string_replacement_values.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Other bonuses: Monuments block enemy god powers within 25 (50 when empowered); empowered Monuments heal nearby units (50 range). Prosperity recharge 120 s."
  },
  "fieldMeta": {
    "modifiers": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ArchaicAgeIsis: techAll food/wood/gold cost x0.90 Percent; Obelisk -5 gold; Priest Obelisk build x1.4 Percent; +5 pop on Town Centers; empower FavorGatherRate x1.667 BasePercent. Ops already match (mul/add)."
    }
  }
}
